export default __webpack_public_path__ + "static/activities_image_five-c1155f372207f8d23e7d0f6c3443e3b1.png";